<template>
  <div
    :class="$style.contextMenu"
    :style="{ left: mouseX + 'px', top: mouseY + 'px' }"
  >
    <div
      :class="$style.resetStatus"
      @click="$emit('update')"
    >
      {{ $t('common.resetDangerLevelTo') }}
      <span :class="$style.greenStatus">{{ $t('common.green') }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['mouseX', 'mouseY'],
  };
</script>

<style lang="scss" module>
  .contextMenu {
    box-shadow: 4px 6px 14px rgba(165, 165, 165, 0.4);
    position: absolute;
    background-color: white;
    width: 300px;
    z-index: 30;
    padding: 10px;
  }

  .resetStatus {
    padding: 3px;
    color: #4b4b4b;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      background: $borderColor;
    }
  }
  .greenStatus {
    color: #1f8d37;
  }
</style>
